module.exports = __webpack_public_path__ + "img/woman.57261edc.png";